export default {"src":"/_next/static/media/shopify.b379e058.svg","height":2500,"width":2192};